import React from 'react';

import { cx } from 'helpers/StylingHelpers';
import { useMediaQuery } from 'hooks/useMediaQuery';

import Modal from '../Modal/Modal';
import ModalBody from '../Modal/ModalBody';

import type { DrawerPosition } from './Drawer';
import type { Props as ModalHeaderProps } from '../Modal/ModalHeader';

import type { Breakpoint, IModalProps } from 'types';

import baseStyles from './Drawer.module.scss';
import styles from './ModalDrawer.module.scss';

export interface Props extends IModalProps {
  className?: string,
  contentClassName?: string,
  innerClassName?: string,
  bodyClassName?: string,
  //
  position: DrawerPosition,
  title: string | React.ReactElement,
  breakpoint?: Breakpoint,
  headerProps?: ModalHeaderProps,
  //
  children: React.ReactElement | React.ReactElement[]
}

const ModalDrawer = (props: Props) => {
  const {
    isOpen,
    //
    className,
    contentClassName,
    innerClassName,
    bodyClassName,
    //
    position,
    title,
    breakpoint = 'lg',
    headerProps,
    //
    children,
    //
    onClose = () => {},
  } = props;

  const isBreakpoint = useMediaQuery(`(max-width: ${styles.breakpoint_sm})`);

  return (
    <Modal
      isOpen={isOpen}
      //
      classNames={{
        overlay: cx(
          baseStyles.root,
          baseStyles.drawer,
          styles.root,
          styles.drawer,
          styles.modal,
          className,
        ),
        content: cx(
          baseStyles.content,
          styles.content,
          contentClassName,
        ),
        inner: cx(
          baseStyles.inner,
          styles.inner,
          innerClassName
        ),
      }}
      //
      withPadding={false}
      withCloseButton={false}
      shouldReserveScrollBarGap={!isBreakpoint}
      desktopProps={{
        position
      }}
      responsiveProps={{
        position
      }}
      //
      onClose={onClose}
    >
      <ModalBody
        classNames={{
          root: cx(
            styles.body,
            bodyClassName
          )
        }}
        headerProps={{
          withPadding: true,
          title,
          withCloseButton: true,
          breakpoint,
          size: 'medium',
          ...headerProps,
          desktopProps: {
            size: 'medium',
            closeIconProps: {
              size: 20,
              strokeWidth: 2.5,
            },
            ...headerProps?.desktopProps,
          },
          responsiveProps: {
            size: 'medium',
            closeIconProps: {
              size: 20,
              strokeWidth: 2.5,
            },
            ...headerProps?.responsiveProps
          },
          onClose,
        }}
      >
        {children}
      </ModalBody>
    </Modal>
  );
};

export default ModalDrawer;
